module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_f_normal.98bf89ec.png";